let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4N508")).then(() => parcelRequire('flTgR'));